module.exports = __webpack_public_path__ + "img/SL.81168561.png";